import React from 'react';
import ReactDOM from 'react-dom';

import Filters from './Components/Filters.jsx';
import Result from './Components/Result.jsx';
import MapView from './Components/MapView.jsx';
import ResultsHeader from './Components/ResultsHeader.jsx';
import Pagination from './Components/Pagination.jsx';
import axios from 'axios';

class EventFinder extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			activeDataset: {
				Query: {
					Status: ["Open"],
					Layout: "list",
					Date:null,
					Category: [],

				},
				Facets: {
					NominalDistances: [],
					Organizers: [],
					AAAOptions: [],
					PoPOptions: [],
					Status: [],
					Categories:[],
					EventDates:[]
				},
				Results: [],
				TotalItems: 0,
				TotalPages: 0,
				CurrentPage: 0,
			},
			loading: true
		}

		this._onFilterChange = this._onFilterChange.bind(this);
		this.loadData = this.loadData.bind(this);
		this._sortChange = this._sortChange.bind(this);
		this._resultLayoutChange = this._resultLayoutChange.bind(this);

	}

	componentDidMount() {
		var model = this._getQuery();
		model.page = 1;
		this.loadData(model);
	}

	loadData(data, scrollToTopAfterLoad) {
		var url = "";
		if (this.props.eventType == "permanentEvents") {
			url = "/umbraco/api/EventSearch/SearchPermanent";
		} else if (this.props.eventType == "calendarEvents") {
			url = "/umbraco/api/EventSearch/SearchCalendar";
		}
		axios
			.post(url, data)
			.then((res) => {
				this.setState({
					activeDataset: res.data,
					loading: false
				}, () => {
					if (scrollToTopAfterLoad) {
						if (this.myResultsRef !== null) {
							this.myResultsRef.scrollIntoView({
								behavior: "smooth",
							});
						}

					}
				})
			});
	}
	_onFilterChange(model, scrollToTopAfterLoad) {
		this.setState({
			loading: true
		}, () => {
			this.loadData(model, scrollToTopAfterLoad);
		});
	}
	_getQuery() {
		return JSON.parse(JSON.stringify(this.state.activeDataset.Query));
	}
	_sortChange(event) {
		var model = this._getQuery();
		model.Sort = event.target.value;
		this._onFilterChange(model);
	}
	_resultLayoutChange(_resultLayoutChange) {
		var model = this._getQuery();
		model.Layout = _resultLayoutChange;
		this._onFilterChange(model);
	}

	renderResults(data) {
		var currentLayout = this.state.activeDataset.Query.Layout;
		if (currentLayout == "list") {
			var results = data.Results.map(function (x) {
				return <Result model={x} key={x.Id} />
			}.bind(this));

			return <>
				{results}
				<Pagination totalPages={data.TotalPages} currentPage={data.CurrentPage} onChange={this._onFilterChange} query={data.Query} />
			</>
		} else if (currentLayout == "map") {
			return <MapView results={data.Results}
				resultsHash={data.ResultsHash}
				hasUserStartPoint={data.HasUserStartPoint}
				locationDistance={data.Query.LocationDistance}
				locationLocalityLat={data.Query.LocationLocalityLat}
				locationLocalityLng={data.Query.LocationLocalityLng}
				onlyShowPin={this.props.eventType == "calendarEvents"}
			/>
		}
	}

	render() {
		var data = this.state.activeDataset;
		return (
			<div className="umb-block-list">
				<section className="g-pb-90">
					<div className="loading-overlay" style={{ display: this.state.loading ? "none" : "none" }}>
						<div className="loading-overlay__inner">
							<div className="loading-overlay__content"><span className="loading-spinner"></span></div>
						</div>
					</div>
					<div className="container " ref={(ref) => this.myResultsRef = ref} >
						<div className="row bg-white border rounded">
							<div className="col-lg-3">
								{data != null && (
									<Filters facetData={data.Facets} query={data.Query} onChange={this._onFilterChange} eventType={this.props.eventType} />
								)}
							</div>
							<div className="col-lg-9">
								{data != null && (
									<>
										<ResultsHeader
											totalResults={data.TotalItems}
											sortChange={this._sortChange}
											selectedSort={this.state.activeDataset.Sort}
											hasUserLocation={data.HasUserStartPoint}
											selectedResultLayout={this.state.activeDataset.Query.Layout}
											resultLayoutChange={this._resultLayoutChange}
											eventType={this.props.eventType}
										/>
										{this.renderResults(data)}

									</>
								)
								}
							</div>

						</div>

					</div>
				</section>
			</div>
		);
	}
}
export default EventFinder;

